import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiCalendar } from 'react-icons/fi';
import { Button } from '@nextui-org/react';

const ProjeComponentInsıde = ({ veri }) => {
  return (
    <div className="flex py-2 mt-2 transition-all duration-500 border-1 dark:border-dark-300 border-gray-200 bg-white dark:bg-dark-300 min-h-[50px] w-full rounded-xl">
      <Link to={'/projects/' + veri.pslug} className="w-full my-2 px-8">
        <div className="flex md:flex-row justify-between w-full">
          <div className="flex flex-row items-start  md:items-start md:gap-3">
            <img
              className="w-16 h-12 rounded-lg object-contain"
              src={veri.pimg !== null ? veri.pimg : "/assets/heypena.png"}
              alt={veri.title}
            />
            <div className="flex flex-col items-start ml-2 mt-[2px]">
              <span className="text-[#283252] dark:text-[#AAAAB3]  font-semibold md:text-[20px]">{veri.pname}</span>
              <span className="text-[#a2a5b9] md:text-[12px] text-xs">{veri.pfirm}</span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-14 mt-3 md:mt-0">
            <div className="flex flex-col items-start justify-center gap-1">
              <div className="flex items-center">
                <FiCalendar className="mr-1 text-[#a2a5b9] text-sm" />
                <div className="text-[#a2a5b9] text-xs md:text-xs">{veri.updated_at}</div>
              </div>
              <div className="flex items-center">
                <FiClock className="mr-1 text-[#a2a5b9] text-sm" />
                <div className="text-[#a2a5b9] md:text-xs text-xs">{veri.updated_at_time}</div>
              </div>
            </div>

            <div className="flex items-center flex-col gap-4 md:flex-row md:gap-0 md:ml-4">
              <div className="text-[#a2a5b9] mr-2 md:text-xs text-xs md:block hidden">{veri.updated_at}</div>
              <div className="bg-[#06D6A0] px-3 rounded-xl text-white text-[14px] py-1 md:ml-10 md:block hidden">Aktif</div>
            </div>

            <Button className="bg-white border-1 dark:bg-dark-300 text-black dark:text-[#a2a5b9] text-xs h-12 w-28 md:block hidden">Görüntüle</Button>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default ProjeComponentInsıde
